import { css } from 'lit';

import color from '../../utils/get-color-token';
import { transition } from '../../styles';

function styles() {
	return [
		css`
			:host {
				--m-icon-size: 16px;
				--m-icon-color: ${color('color-text-primary')};

				display: inline-flex;
				align-items: center;
				justify-content: center;

				inline-size: var(--m-icon-size);
				block-size: var(--m-icon-size);
			}

			svg {
				${transition([{ property: 'color' }, { property: 'fill' }])};

				inline-size: var(--m-icon-size);
				block-size: var(--m-icon-size);

				color: var(--m-icon-color);
				fill: var(--m-icon-color);
			}
		`,
	];
}

export default styles;
